import type { IconData } from '@stacksjs/iconify-core'

export const clockTwo: IconData = {
  "body": "<circle cx=\"12\" cy=\"12\" r=\"10\" fill=\"currentColor\" opacity=\".5\"/><path fill=\"currentColor\" d=\"M11 7a1 1 0 0 1 2 0v3.268l1.098-.634a1 1 0 0 1 1 1.732l-2.598 1.5A1.014 1.014 0 0 1 11 12Z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default clockTwo
